import React, { useState, useEffect, useRef } from 'react';
import $ from 'jquery';
import "bootstrap/dist/css/bootstrap.min.css"; // Bootstrap 5
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css"; // DataTable Bootstrap 5 Styles
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css"; // DataTable Bootstrap 5 Responsive
import "datatables.net-bs5";
import "datatables.net-responsive-bs5";
import * as XLSX from 'xlsx'; 
import { Button, Container, Row, Col, Card, Table, Spinner, Modal, Form } from 'react-bootstrap';
import './index.css';
import Header from '../Header';
import { useNavigate } from 'react-router-dom';

const AssignedEmp = () => {
  const [emp, setEmp] = useState([]);  
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true); 
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false); 
  const [selectedEmp, setSelectedEmp] = useState(null); 
  const [selectedEmployee, setSelectedEmployee] = useState(''); 
  const [successMessage, setSuccessMessage] = useState(null); 
  const [reAssign, setReassign] = useState(null); 
  const tableRef = useRef(null);
  const id = localStorage.getItem('userId');
  const navigate = useNavigate();

  // Fetch employee data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/showtasks/${id}`);
        
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const result = await response.json();  
        console.log(result);
        setEmp(result.task || []);  

        const empResponse = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/employee/${id}`);
           const empData = await empResponse.json();
           //setEmployees(empData || []);     
           if (Array.isArray(empData)) {
            setEmployees(empData || []);
          } else {
            console.error("Employee data is not in expected array format", empData);
            setEmployees([]);  // Fallback to empty array in case of invalid data
          }
        
      } catch (error) {
        console.error("Error fetching data:", error); 
        setError(error.message);  
      } finally {
        setLoading(false);  
      }
    };

    fetchData(); 
  }, []);

  // Initialize DataTable after employee data is fetched
  useEffect(() => {
    if (emp.length > 0 && tableRef.current) {
      const table = $(tableRef.current).DataTable({
        responsive: true,
        autoWidth: false,
        destroy: true, 
        paging: true,
        pageLength: 10, 
        lengthMenu: [10, 25, 50, 100], 
        columnDefs: [
          { targets: 0, responsivePriority: 1 },
          { targets: 1, responsivePriority: 2 },
          { targets: 2, responsivePriority: 3 },
          { targets: 3, responsivePriority: 4 },
          { targets: 4, responsivePriority: 5 },
          { targets: 5, responsivePriority: 6 },
          { targets: 6, responsivePriority: 7 },
        ],
      });

      return () => {
        table.destroy(); // Cleanup on unmount
      };
    }
  }, [emp]);

  const handleAssignSubmit = async () => {
    if (!selectedEmployee) {
      alert("Please select an employee.");
      return;
    }
    setReassign(true);
  
    try {
      // Prepare the payload for the API request
      const payload = {
        emp_id: selectedEmployee,
      };
  
      // Send the API request to assign the ticket
      const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/reasign/${selectedEmp.id}`, {
        method: 'PUT', // Use PUT if the API expects a PUT request
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
  
      // Check if the response is okay
      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.message || 'Failed to assign the ticket');
      }
  
      const responseData = await response.json();
      setSuccessMessage('Task assigned successfully!');
      setError(null);
  
      setShowModal(false);
      setSelectedEmployee('');
      setTimeout(() => {
         setSuccessMessage('Task assigned successfully!');
         window.location.reload();
       }, 3000);
    } catch (error) {
      setError(error.message); 
      setSuccessMessage(null);  
    } finally {
      setReassign(false); 
    }
  };

  const handleAssignButtonClick = (emp) => {
    setSelectedEmp(emp);
    setShowModal(true); 
  };

  const exportToExcel = () => {
    if (emp.length === 0) {
      alert("No data to export");
      return;
    }

    const ws = XLSX.utils.json_to_sheet(emp);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "emp");

    XLSX.writeFile(wb, "Employee_List.xlsx");
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <>
     <Header />
    
    <div className="shadow mx-1 px-3 bg-light rounded-3">
      <div className="d-flex align-items-center justify-content-between p-3 mt-3">
        <h4 className="mb-0">Assigned Task List</h4>
        <button className="btn btn-success" onClick={exportToExcel}>
          Export to Excel
        </button>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}
      {successMessage && <div className="alert alert-success">{successMessage}</div>}

      <div className="card">
        <div className="card-header">Task List</div>
        <div className="card-body">
          <div className="table-responsive">
            <table
              ref={tableRef}
              className="table table-striped table-bordered display nowrap"
              style={{ width: '100%' }}
            >
              <thead>
                <tr>
                  <th>S.no</th>
                  <th>Task Id</th>
                  <th>Company</th>
                  <th>Plan</th>
                  <th>Service Task</th>
                  <th>Description</th>
                  <th>Assigned To</th>
                  <th>Emp Description</th>
                  <th>Status</th>
                  <th>Action</th>                  
                  <th>Assigned On</th>
                  <th>Closed On</th>
                  
                </tr>
              </thead>
              <tbody>
                {emp.length > 0 ? (
                  emp.map((emp, index) => (
                    <tr key={emp.id}>
                      <td>{index + 1}</td>
                      <td className="text-danger">{emp.task_uniqueid || 'N/A'}</td>
                      <td className="text-primary">{emp.Username || 'N/A'}</td>
                      <td>{emp.Plan || 'N/A'}</td>
                      <td>{emp.Sname === 'Others' ? (
                         emp.other_service_task
                        ) : (
                          emp.Sname
                        )}                      
                      </td>
                      <td>{emp.Task_Description || 'N/A'}</td>
                      <td className="text-primary">{emp.EmpName || 'N/A'}</td>
                      <td>{emp.Emp_Description || 'N/A'}</td>
                      <td className={emp.status === 'open' ? 'text-primary' : 'text-danger'}>
                        {emp.status || 'N/A'}
                      </td>
                      <td>{emp.status === 'open' ? (
                        <button className="btn btn-warning ms-2 p-1 m-1" onClick={() => handleAssignButtonClick(emp)}>Re-Assign</button>
                        ) : (
                          <span></span>
                        )}
                          <button className="btn btn-info p-1 m-1" onClick={() => navigate(`/Quries/${emp.task_uniqueid}`)}>
                              View Queries
                          </button>                        
                      </td>
                      <td>{emp.doa || 'N/A'}</td>
                      <td>{emp.task_cdate || 'N/A'}</td>   
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5">No employees available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    {/* Modal for assigning the ticket */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Re-Assign Task</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="assignTo">
              <Form.Label>Assign To</Form.Label>
              <Form.Control as="select" name="emp_id" value={selectedEmployee} onChange={(e) => setSelectedEmployee(e.target.value)} >
                <option value="">Select Employee</option>
                {Array.isArray(employees) && employees.filter((employee) => employee.id !== selectedEmp?.emp_id) 
                  .map((employee) => (
                    <option key={employee.id} value={employee.id}>
                      {employee.name}
                    </option>
                  ))}
              </Form.Control>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>          
          <Button variant="primary" onClick={handleAssignSubmit} disabled={reAssign}>
            {reAssign ? (
              <>
                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                Assigning...
              </>
            ) : (
              "Assign Task"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AssignedEmp;
